import {MuseOn} from "./MuseOn";
import {ArtworkCategory} from "./artwork-category";

export class Artwork extends MuseOn {
    _id: string;
    name: string;
    code: number;
    price: number;
    image_cover: string;
    link_banner: string;
    image_banner: string;
    database_id: string;
    group_id: string;
    route_id: string;
    categories: Array<ArtworkCategory>;

    constructor (data) {
        super();

        this._id = data._id;
        this.name = data.name;
        this.code = data.code;
        this.price = data.price;
        this.group_id = data.group_id;
        this.route_id = data.route_id;
        this.image_cover = data.image_cover;
        this.link_banner = data.link_banner;
        this.database_id = data.database_id;
        this.image_banner = data.image_banner;
        this.categories = data.categories ? data.categories.map(category => new ArtworkCategory(category)) : [];
    }

    getObj(removeNull: boolean = false) {
        const result =  {
            name: this.name,
            price: this.price,
            code: this.code,
            image_cover: this.image_cover,
            group_id: this.group_id ,
            route_id: this.route_id ,
            link_banner: this.link_banner,
            image_banner: this.image_banner,
            categories: this.categories,
        };

        return removeNull
            ? this.removeNull(result)
            : result
        ;
    }
}
